import { render, staticRenderFns } from "./DrawerCard.vue?vue&type=template&id=5c51edf5&scoped=true"
import script from "./DrawerCard.vue?vue&type=script&lang=js"
export * from "./DrawerCard.vue?vue&type=script&lang=js"
import style0 from "./DrawerCard.css?vue&type=style&index=0&id=5c51edf5&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c51edf5",
  null
  
)

export default component.exports